"use strict";

import "./UserPassword.css";
import React from "react";

import dispatcher from "./../../dispatcher";

import Card from "vwa/components/Card";
import ProgressBar from "vwa/components/ProgressBar";
import Toast from "vwa/components/Toast";
import Form from "vwa/components/Form";
import Input from "vwa/components/Input";
import Button from "vwa/components/Button";
import lang from "vwa/lang";

import changePassword from "./../../api/changePassword";

export default class UserPassword extends React.Component {

	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = {
			oldPassword: "",
			newPassword1: "",
			newPassword2: "",
			errorMessage: "",
			inProgress: false
		};
	}
	
	clear() {
		this.setState({
			oldPassword: "",
			newPassword1: "",
			newPassword2: "",
			errorMessage: ""
		});
	}
	
	check() {
		if (this.state.newPassword1 !== this.state.newPassword2) {
			this.setState({errorMessage: lang.CONFIRM_PASSWORD_ERROR_MESSAGE});
			return false;
		} else {
			this.setState({errorMessage: ""});
			return true;
		}
	}
	
	handleInputChange(which, value) {
		this.setState({
			[which]: value
		});
	}
	
	handleSave() {
		if (!this.check())
			return;
		this.changePassword();
	}
	
	async changePassword() {
		this.setState({inProgress: true});
		try {
			await changePassword(this.state.oldPassword, this.state.newPassword2);
			this.clear();
			new Toast(lang.CHANGE_PASSWORD_SUCCESSFUL);
		} catch (error) {
			this.setState({
				errorMessage: error.message
			});
		}
		this.setState({inProgress: false});
	}
	
	getSaveButtonDisabled() {
		if (!this.state.oldPassword || !this.state.newPassword1 || !this.state.newPassword2)
			return true;
		return false;
	}
	
	render(){
		return(
			<div className="UserPassword">
				<header className="Shadowed">
					<Button className="Red" disabled={this.getSaveButtonDisabled()} onClick={_ => this.handleSave()}>{lang.SAVE}</Button>
				</header>
				<div className="Content">
					<ProgressBar indeterminate shown={this.state.inProgress} />
					<Card className={this.state.inProgress ? "Hidden" : null}>
						<Form>
							<span className={!this.state.errorMessage ? "Hidden" : ""} id="errorMessage">{this.state.errorMessage}</span>
							<label>{lang.OLD_PASSWORD}</label>
							<Input type="password" value={this.state.oldPassword} onChange={evt => this.handleInputChange("oldPassword", evt.target.value)} />
							<label>{lang.NEW_PASSWORD}</label>
							<Input type="password" value={this.state.newPassword1} onChange={evt => this.handleInputChange("newPassword1", evt.target.value)} />
							<label>{lang.CONFIRM_NEW_PASSWORD}</label>
							<Input type="password" value={this.state.newPassword2} onChange={evt => this.handleInputChange("newPassword2", evt.target.value)} />
						</Form>
					</Card>
				</div>
			</div>
		);
	}

}

UserPassword.propTypes = {
	
};

UserPassword.defaultProps = {
	
};


// WEBPACK FOOTER //
// ./src/view/UserPassword/UserPassword.jsx